const initQxHome = () => {
  const main = document.getElementById('MainContent');

  if (!main || main.dataset.template !== 'index' || !main.querySelector('.qx-section')) return;

  document.documentElement.classList.add('qx-home-ready');

  const revealTargets = main.querySelectorAll(
    [
      '.qx-section-heading',
      '.qx-reel-card',
      '.qx-product-card',
      '.qx-benefit',
      '.qx-guide__media',
      '.qx-guide__content',
      '.qx-article-card',
      '.qx-reviews',
      '.qx-faq__grid',
      '.qx-newsletter__inner',
      '.qx-trust-strip__item',
      '.qx-footer__brand',
      '.qx-footer__nav',
      '.qx-footer__newsletter',
    ].join(',')
  );

  revealTargets.forEach((target, index) => {
    target.classList.add('qx-reveal');
    target.style.setProperty('--qx-reveal-delay', `${Math.min(index % 6, 5) * 70}ms`);
  });

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      {
        rootMargin: '0px 0px -10% 0px',
        threshold: 0.12,
      }
    );

    revealTargets.forEach((target) => observer.observe(target));
  } else {
    revealTargets.forEach((target) => target.classList.add('is-visible'));
  }

  const header = document.querySelector('#header-group');

  if (header) {
    const setHeaderState = () => {
      header.classList.toggle('qx-header-scrolled', window.scrollY > 50);
    };

    setHeaderState();
    window.addEventListener('scroll', setHeaderState, { passive: true });
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initQxHome, { once: true });
} else {
  initQxHome();
}